export const PATH_LOGIN = '/api/v2/login';
export const PATH_FEDERATED_LOGIN = '/api/v2/login/federated';
export const PATH_LOGOUT = '/api/v2/logout';
export const PATH_ME = '/api/v2/userme';
export const PATH_RESET_PASS = '/api/v2/resetpass';
export const PATH_GET_TOKEN_INFO = '/api/v2/gettokeninfo';
export const PATH_RESET_PASS_CHANGE = '/api/v2/changepass';
